import {
  Box,
  Button,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { AssetTypes } from "common/backend/types/utils";
import { CommonLinearProgress } from "common/components/CommonLinearProgress";
import { SaleManageable } from "common/store/sale/types";
import { formatDateDifference } from "common/utils/utility";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface Props {
  sale: SaleManageable;
  selected: boolean;
}

const paperStyle = makeStyles({
  root: {
    height: "522px",
    "&:first-child": {
      borderBottomLeftRadius: "0px",
      height: "100%",
      borderTopLeftRadius: "0px",
    },
  },
});

const paperNoSelectedStyle = makeStyles({
  root: {
    height: "480px",
    "&:first-child": {
      borderBottomLeftRadius: "0px",
      height: "100%",
      borderTopLeftRadius: "0px",
    },
  },
});

const paperNoSelectedLoanStyle = makeStyles({
  root: {
    "&:first-child": {
      borderBottomLeftRadius: "0px",
      height: "100%",
      borderTopLeftRadius: "0px",
    },
  },
});

const paperSelectedLoanStyle = makeStyles({
  root: {
    "&:first-child": {
      borderBottomLeftRadius: "0px",
      height: "100%",
      borderTopLeftRadius: "0px",
    },
  },
});

const itemTextStyle = makeStyles({
  root: {
    fontSize: 18,
    fontWeight: 500,
    color: "#696F74",
    marginBottom: 12,
  },
});

const itemValueStyle = makeStyles({
  root: {
    color: "#4A4A4A",
    fontSize: 18,
    fontWeight: 500,
  },
});

export const SaleInfo: React.FC<Props> = ({
  sale, selected
}) => {
  const history = useHistory();
  const itemText = itemTextStyle();
  const itemValue = itemValueStyle();
  const paper = paperStyle();
  const paperNo = paperNoSelectedStyle();
  const paperNoLoan = paperNoSelectedLoanStyle();
  const paperLoan = paperSelectedLoanStyle();

  const nFormatter = (num: number) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(
        /\.0$/,
        ""
      ) + "G";
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(
        /\.0$/,
        ""
      ) + "m";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(
        /\.0$/,
        ""
      ) + "k";
    }
    return num;
  };

  const { t } = useTranslation();

  const duration = formatDateDifference(
    sale.endDate,
    sale.startDate
  );

  return (
    <Paper
      classes={
        selected && sale.assetType !== AssetTypes.LOAN
          ? paper
          : selected && sale.assetType === AssetTypes.LOAN
            ? paperLoan
            : sale.assetType === AssetTypes.LOAN
              ? paperNoLoan
              : paperNo
      }
    >
      <Box
        paddingX="10%"
        paddingTop="84px"
        paddingBottom="100px"
        boxSizing="border-box"
        textAlign="center"
      >
        <Typography className={"sale-name" + (selected ? "--selected" : "")}>
          {sale.title}
        </Typography>
        <Box
          paddingTop="20px"
          marginTop="20px"
          boxSizing="border-box"
          textAlign="initial"
        >
          <Grid container>
            <Grid item xs={6}>
              <Typography classes={itemText}>
                {t("Time till repayed")}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right" classes={itemValue}>
                {duration}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography classes={itemText}>{t("Returns p.a.")}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right" classes={itemValue}>
                €{nFormatter(1232.0)}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography classes={itemText}>
                {t("Shares Available")}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right" classes={itemValue}>
                {nFormatter(Number(sale.sharesAvailable))}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box paddingY="20px" boxSizing="border-box">
          <CommonLinearProgress
            label={t("Funded")}
            value={sale.percentageFunded}
          />
        </Box>
        <Button
          className="primary"
          variant="contained"
          onClick={() => history.push(`/offering/${sale.id}/${sale.assetType}`)}
        >
          {t("Explore project")}
        </Button>
      </Box>
    </Paper>
  );
};
